import gql from 'graphql-tag';

export const EHRENAMTLICHE_FINDEN_INFORMATION_FRAGMENT = gql`
    fragment ehrenamtlicheFindenInfo on EhrenamtlicheFindenInfoType {
    infoTitle
    infoText
    infoButtonText
    infoButtonUrl
    infoImageOne
    infoImageTextOne
    infoImageTwo
    infoImageTextTwo
    infoImageThree
    infoImageTextThree
    id
  }
`;